<div class="adn-form-field adn-form-field-disabled">
    <label *ngIf="label">
        <span *ngIf="iconClass" class="fal fa-fw adn-color-primary" [ngClass]="iconClass" aria-hidden="true"></span>
        {{label}}
    </label>
    <div class="adn-form-field-content">
        <ng-content></ng-content>&nbsp;
        <app-help-popup-button class="input-icon" *ngIf="helpUri" [uri]="helpUri"></app-help-popup-button>
    </div>
</div>